var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded)?_c('tab-test'):(_vm.error)?_c('error-view',{attrs:{"error":_vm.error},on:{"reload":_vm.load}}):_c('vpreloader')
}
var staticRenderFns = []

export { render, staticRenderFns }